import React from "react";
import { Container } from "react-bootstrap";
import Header from "./HeaderNew";
import Footer from "./FooterNew";
import EmptyRow from "../../components/emptyRow/EmptyRow";
import { isUserType } from "../../features/localStorage";

const Layout = ({ props, children }: { props: any; children: any }) => {
  return (
    <>
      <Header />
      <div className="desk">
        <EmptyRow />
        <EmptyRow />
        <EmptyRow />
      </div>
      <EmptyRow />
      <Container fluid className="px-5 py-1" style={{ marginBottom: 70 }}>
        <EmptyRow />
        {children}
        <EmptyRow />
      </Container>
      <Footer userType={2} />
    </>
  );
};

export default Layout;
